import { TenantEntity } from '../TenantEntity'

export class AgentCharge extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'AgentCharge'
  }
  get agentChargeId() {
    return this._data.agentChargeId
  }

  set agentChargeId(agentChargeId) {
    this._data.agentChargeId = agentChargeId
  }

  get ar() {
    return this._data.ar
  }

  set ar(ar) {
    this._data.ar = ar
  }

  get percentage() {
    return this._data.percentage
  }

  set percentage(percentage) {
    this._data.percentage = percentage
  }

  get chargeItemId() {
    return this._data.chargeItemId
  }

  set chargeItemId(chargeItemId) {
    this._data.chargeItemId = chargeItemId
  }

  get currency() {
    return this._data.currency
  }

  set currency(currency) {
    this._data.currency = currency
  }

  get rate() {
    return this._data.rate
  }

  set rate(rate) {
    this._data.rate = rate
  }

  get amount() {
    return this._data.amount
  }

  set amount(amount) {
    this._data.amount = amount
  }

  get type() {
    return this._data.type
  }

  set type(type) {
    this._data.type = type
  }

  get quantity() {
    return this._data.quantity
  }

  set quantity(quantity) {
    this._data.quantity = quantity
  }

  get unitPrice() {
    return this._data.unitPrice
  }

  set unitPrice(unitPrice) {
    this._data.unitPrice = unitPrice
  }

  get remark() {
    return this._data.remark
  }

  set remark(remark) {
    this._data.remark = remark
  }

  get inputBy() {
    return this._data.inputBy
  }

  set inputBy(inputBy) {
    this._data.inputBy = inputBy
  }

  get inputDate() {
    return this._data.inputDate
  }

  set inputDate(inputDate) {
    this._data.inputDate = inputDate
  }

  get serialNumber() {
    return this._data.serialNumber
  }

  set serialNumber(serialNumber) {
    this._data.serialNumber = serialNumber
  }

  get paymentType() {
    return this._data.paymentType
  }

  set paymentType(paymentType) {
    this._data.paymentType = paymentType || false
  }

  get billingUuid() {
    return this._data.billingUuid
  }

  set billingUuid(billingUuid) {
    this._data.billingUuid = billingUuid
  }

  get jobUuid() {
    return this._data.jobUuid
  }

  set jobUuid(jobUuid) {
    this._data.jobUuid = jobUuid
  }
}
